import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { getPaymentStatus } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("unknown"); return; }
    let tries = 0;
    const timer = setInterval(async () => {
      tries += 1;
      try {
        const d = await getPaymentStatus(sessionId);
        if (d.payment_status === "paid") {
          setStatus("paid");
          clearInterval(timer);
        } else if (tries > 12) {
          setStatus("pending");
          clearInterval(timer);
        }
      } catch {
        if (tries > 12) { setStatus("pending"); clearInterval(timer); }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6 pt-24" data-testid="payment-success-page">
      <div className="text-center max-w-md">
        <span className="mx-auto w-16 h-16 rounded-full bg-mint grid place-items-center">
          <CheckCircle2 size={30} className="text-teal" />
        </span>
        <h1 className="font-display font-bold text-4xl text-teal mt-6">
          {status === "paid" ? "Payment Received" : status === "checking" ? "Confirming Payment..." : "Almost There"}
        </h1>
        <p className="mt-4 text-teal/70 leading-relaxed">
          {status === "paid"
            ? "Grazie! Your order is paid and confirmed. We'll have it ready at the counter — a confirmation email is on its way to you."
            : status === "checking"
            ? "We're just confirming your payment with the bank — this takes a few seconds."
            : "Your payment is being processed. If you've been charged, your order is safe — show any confirmation email at the counter."}
        </p>
        <Link to="/shop" data-testid="success-back-link"
          className="mt-8 inline-block rounded-full bg-teal text-cream px-8 py-3.5 text-xs uppercase tracking-[0.2em] hover:bg-gold hover:text-teal-deep transition-colors">
          Back to the Shop
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
